module.exports = __webpack_public_path__ + "img/title.68ffc0c3.png";